//TODO: GROW-2166 when Productizing if fixed win update the InverseHeader in core component and fix imports
import {
  LayoutGrid,
  SwipeableProvider,
  TypographyV3,
} from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import { galleryImagesOR4 } from '@/app/[locale]/careers/_data/galleryImages';
import InverseHeader from '@/app/components/Experiments/FixedHeader/InverseHeader/InverseHeader';
import Section from '@/app/components/LegacyLandingPage/components/Section';

import Gallery from './Gallery';

const CareersGallery = () => {
  const t = useTranslations();

  return (
    <Section padTop data-cy="careers-gallery">
      <LayoutGrid>
        <TypographyV3
          className="col-main mb-8 lg:mb-0"
          variant="h1"
          weight="light"
        >
          {t('how_it_started')}
        </TypographyV3>
      </LayoutGrid>

      <LayoutGrid>
        <TypographyV3 className="col-main md:col-start-3 lg:col-start-6 lg:col-end-14 xl:col-end-13">
          {t('what_started_as_an_idea')}
        </TypographyV3>
      </LayoutGrid>

      <InverseHeader enter>
        <LayoutGrid className="pt-12">
          <SwipeableProvider className="col-main">
            <Gallery images={galleryImagesOR4} />
          </SwipeableProvider>
        </LayoutGrid>
      </InverseHeader>
    </Section>
  );
};

export default CareersGallery;
